import * as PropTypes from 'prop-types';
import React, { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CARGO_TYPE } from '../../cargoType';
import CargoTypeListToggler from '../../cargoType/CargoTypeListToggler';
import { ActionPropTypes } from '../../layout/Datagrid';
import { ListPageWithPersisted } from '../../layout/ListPage';
import LoadingIndicator from '../../layout/loading/LoadingIndicator';
import { getTransactionListOptions } from '../helpers/listHelpers';
import TransactionHeaderActions from '../TransactionHeaderActions';
import AdvancedFiltersSection from './AdvancedFiltersSection';
import getColumns from './columnsSettings';
import useGetBulkTransactions from './useGetBulkTransactions';
import useGetBulkTransactionsOptions from './useGetBulkTransactionsOptions';
import ListPageHeaderWithDateFilter from '../../layout/ListPage/headers/ListPageHeaderWithDateFilter';

const header = (props) => {
  const dateFilterOptions = {
    propertyNames: { from: 'effectiveDateFrom', to: 'effectiveDateTo' },
    canClearFilter: false,
  };
  return <ListPageHeaderWithDateFilter {...props} dateFilterOptions={dateFilterOptions}></ListPageHeaderWithDateFilter>;
};

const BulkTransactionList = ({ actions }) => {
  const { t, i18n } = useTranslation('transaction');
  const [fetchTransactions, data = {}, isLoading] = useGetBulkTransactions();

  const [fetchTransactionsOptions, options] = useGetBulkTransactionsOptions();

  const columns = useMemo(() => {
    const listOptions = getTransactionListOptions(options, t);
    return getColumns(listOptions, t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, i18n.language]);

  useEffect(() => {
    fetchTransactionsOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  useEffect(() => {
    const listType = localStorage.getItem('listType');
    if (listType || !Array.isArray(data?.items)) return;
    if (data.items.length > 0) {
      localStorage.setItem('listType', 'bulk');
    }
  }, [data]);

  return (
    <>
      <LoadingIndicator show={isLoading} />
      <ListPageWithPersisted
        header={header}
        title={t('transactions')}
        defaultColumnWidth={75}
        checkable={false}
        noRowLink
        data={data}
        columns={columns}
        withPresets
        translater={t}
        fetcher={fetchTransactions}
        actions={actions}
        rowKey="documentId"
        headerProps={{
          actions: <TransactionHeaderActions totalItemsCount={data?.totalItems || 0} cargoType={CARGO_TYPE.bulk} />,
          advancedFilterSection: AdvancedFiltersSection,
          subscript: <CargoTypeListToggler />,
        }}
      />
    </>
  );
};

BulkTransactionList.propTypes = {
  actions: PropTypes.arrayOf(ActionPropTypes),
};

export default BulkTransactionList;
